import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDecline = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10.625,
		r: 10,
		fill: "#f4423f"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9193 7.70703L7.08594 13.5404M7.08594 7.70703L12.9193 13.5404",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDecline;
